import { render, staticRenderFns } from "./CotizacionesTableComponent.vue?vue&type=template&id=0c80ded0&"
import script from "./CotizacionesTableComponent.vue?vue&type=script&lang=js&"
export * from "./CotizacionesTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports